import Isotope from "isotope-layout";
import imagesLoaded from 'imagesloaded';

const tilesContainerId = 'lb-np-tiles';
const tilesEditionFilterId = 'np-edition-filters';
const tilesSectionFilterId = 'np-section-filters';
const tilesEditionSelector = '.np-edition-selector';
const tilesSectionSelector = '.np-section-selector';

let tilesContainerElement;
let tilesEditionFilterElement;
let tilesSectionFilterElement;
let tilesIso;

// Define getColumnWidth function, this should match the classes used in the container with the IsoTope selector (see tilesSelector above)
function getColumnWidth() {
  if (window.matchMedia('(min-width: 992px)').matches) {
      // Large devices (≥992px)
      return '.col-lg-4';
  } else {
      // Medium devices (≥768px) and small devices (≥576px)
      return '.col-md-6';
  }
}

// Plain Javascript DOM callback(s)
let callback = function() {
  // Handler when the DOM is fully loaded

  // get the element to for the NP Tiles and Filter
  tilesContainerElement = document.getElementById(tilesContainerId);
  tilesEditionFilterElement = document.getElementById(tilesEditionFilterId);
  tilesSectionFilterElement = document.getElementById(tilesSectionFilterId);


  // Define Isotope options
  const isoTopeOptions = {
    itemSelector: tilesEditionSelector,
    layoutMode: 'masonry',
    masonry: {
        columnWidth: getColumnWidth()
    },
    // filter: '.E2024',
  };
 // Create Isotope object
 const isoTopeObject = new Isotope(tilesContainerElement, isoTopeOptions);

   // Wait for elements to load
   imagesLoaded(tilesContainerElement).on('progress', function() {
    // Re-layout Isotope after elements load
    isoTopeObject.layout();
  });

  // Update column width on window resize
  window.addEventListener('resize', function() {
    isoTopeObject.masonry.columnWidth = getColumnWidth();
    isoTopeObject.layout();
  });

  // set the on-click events for the filter items
  const onClickFunction = isoFilterSelectFunc(isoTopeObject);
  const lis = tilesEditionFilterElement.querySelectorAll('li');
  lis.forEach(element => {
    element.addEventListener('click', function() { onClickFunction(this) });
  });

  // creates a closure for the filter onclick events
  // the global isoTope object is used by the closure
  function isoFilterSelectFunc(isoTopeObj) {
    return function(element) {
      element.parentElement.querySelectorAll('li').forEach(e => {e.classList.remove("active");});
      element.classList.add("active");

      let filterValue = element.getAttribute('data-edition-filter');
      isoTopeObj.arrange({filter: filterValue});
    };
  }
  
};
// End of DOM Callback Function(s)

if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener("DOMContentLoaded", callback);
}
